import withAlmToken from '../../common/withAlmToken';
import Settings from './UserSettings';
export default withAlmToken(Settings);
